<app-abandon-accounts
  (noContinue)="closePopin()"
  (yesAbandon)="abandon()"
  [show]="isPopinOpen"
></app-abandon-accounts>

<div
  class="w-full max-w-600px d-flex flex-col justify-center items-center text-center"
  *ngIf="status === 'SUCCESS'"
>
  <span class="text-primary picto-bank-check picto-size-13"></span>

  <h1 class="mb-5 mt-1 font-20 font-md-24">
    {{ 'accounts_answer_success_title' | translate }}
  </h1>

  <p class="font-14 font-md-16">
    {{ 'accounts_answer_success_message' | translate }}
  </p>

  <button (click)="continueSuccess()" class="btn bg-primary rounded-full px-10 mt-10">
    {{ 'common_continue' | translate }}
  </button>

  <div class="notice mt-10">
    <img
      class="self-center w-78px w-md-100px"
      src="../../../../../assets/images/svg/info_circle.svg"
      alt="info circle"
    />

    <div class="ml-6 text-left">
      <p [innerHTML]="'accounts_answer_success_notice_p1' | translate" class="font-14 font-md-16"></p>
      <p [innerHTML]="'accounts_answer_success_notice_p2' | translate" class="font-14 font-md-16"></p>
    </div>
  </div>
</div>

<div
  *ngIf="status !== 'SUCCESS'"
  class="w-full max-w-600px d-flex flex-col justify-center items-center text-center"
>
  <span class="text-primary picto-bank-exclamation picto-size-13"></span>
  <h2 class="font-20 font-md-24">
    {{ 'connection_error_failure' | translate }}
  </h2>

  <div *ngIf="status === 'RETRY_ACCOUNT' || status === 'RETRY_BANK'" class="d-flex flex-col">
    <div *ngIf="status === 'RETRY_ACCOUNT'" class="pb-3">
      <p [innerHTML]="'accounts_answer_retry_other_account_text' | translate" class="font-14 font-md-16"></p>

      <p
        [innerHTML]="'accounts_answer_retry_other_account_astuce' | translate"
        class="font-14 font-md-16"
      ></p>
    </div>

    <div *ngIf="status === 'RETRY_BANK'" class="pb-3">
      <p [innerHTML]="'accounts_answer_retry_other_bank_text' | translate" class="font-14 font-md-16"></p>
      <p [innerHTML]="'accounts_answer_retry_other_bank_astuce' | translate" class="font-14 font-md-16"></p>
    </div>

    <div>
      <button (click)="selectBank()" class="btn bg-primary rounded-full px-5">
        {{ 'connect_to_other_bank_btn' | translate }}
      </button>
    </div>

    <a (click)="openPopin()" class="text-dark mt-10" role="button">{{
      'select_accounts_abandon' | translate
    }}</a>
  </div>

  <div *ngIf="status === 'FAILED'">
    <p [innerHTML]="'accounts_answer_failed_text' | translate" class="font-md-16 pb-4"></p>

    <p class="font-14 font-md-16">
      {{ 'connection_error_text2' | translate }}
      <strong>{{ 'connection_error_text3' | translate }}</strong>
    </p>

    <button (click)="continueFailure()" class="btn bg-primary rounded-full px-10 mt-10">
      {{ 'common_continue' | translate }}
    </button>
  </div>
</div>
